import { HTTP } from '../../utils'

export const createOrUpdateMicroCompetency = (mc) => {
  var url = 'mc/'
  if (mc.uuid) {
    url += mc.uuid
  }
  return HTTP().put(url, mc)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
    return e.response
  })
}
export const updateChildMicroCompetencies = (uuid) => {
  var url = 'mc/update/copies/'+uuid
  return HTTP().put(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
    return e.response
  })
}
export const makeCopy = (uuid) => {
  var url = 'mc/copyfrom/'+uuid
  return HTTP().put(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
    return e.response
  })
}
export const getMicrocompetencies = (page, count, title, published) => {
  var url = 'mc/manage?page=' + page + '&count=' + count
  if (title) {
    url += '&title=' + title
  }
  if (published) {
    url += '&published=' + published
  }
  return HTTP().get(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getMicroCompetencyDetail = (uuid) => {
  return HTTP().get('mc/' + uuid)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const getMicroCompetencyAssets = (uuid) => {
  return HTTP().get('mc/' + uuid+'/withPlan')
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const deleteMultipleMicroCompetencies = (uuids) => {
  return HTTP().delete('mc/multiple?uuids=' + uuids)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const loadMicroCompetencyUnlockFor = (mcId) => {
  return HTTP().get('mc/unlocked/' + mcId)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const unlockMicroCompetencyForUsers = (mcId, selectionType, userIds) => {
  return HTTP().put('mc/unlock/'+mcId+'/for/'+selectionType+'?userIds='+userIds)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const publishMultipleMicroCompetencies = (uuids, flag) => {
  return HTTP().put('mc/publish/multiple?uuids=' + uuids+'&flag='+flag)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const publishOneMicroCompetency = (uuid) => {
  return HTTP().put('mc/publish/' + uuid)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const saveMicroCompetencyPrereqs = (data) => {
  let url = '/mc/prereqs'
  return HTTP().put(url, data)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error: ' + e)
  })
}

export const curateMicroCompetency = (data) => {
  let url = '/mc/curate'
  return HTTP().put(url, data)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error: ' + e)
  })
}

export const getMicroCompetencySubjects = () => {
  return HTTP().get('mc/subject')
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getMicroCompetencyModules = () => {
  return HTTP().get('mc/module')
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}




// WEBPACK FOOTER //
// ./src/app/microCompetency/api.js